export enum RouteName {
  home = 'demo-account',
}
